import loadable from '@loadable/component';

export const LoadableUnsupportedCountriesPage = loadable(
  () =>
    import(
      /* webpackChunkName: "UnsupportedCountriesPage" */ './UnsupportedCountriesPage'
    ),
);
